export const ACTIONS = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_START: 'RESET_PASSWORD_START',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
  RESET_RESET_PASSWORD: 'RESET_RESET_PASSWORD',
};
